<template>
  <div class="home-page">
    <section class="hero-section">
      <div class="container hero-container">
        <div class="hero-content">
          <h1>Innovative Technology Solutions</h1>
          <p>We deliver cutting-edge software solutions that drive business growth and digital transformation. From web development to cloud solutions, we're your trusted technology partner.</p>
          <div class="hero-buttons">
            <router-link to="/services" class="btn btn-primary">Our Services</router-link>
            <router-link to="/contact" class="btn btn-secondary">Get Started</router-link>
          </div>
        </div>
      </div>
    </section>

    <section class="who-we-are-section">
      <div class="container">
        <div class="who-we-are-content">
          <div class="who-we-are-badge">WHO WE ARE</div>
          <h2>Outsourcing Solutions<br>Built for Growth.</h2>
          <router-link to="/about" class="btn btn-who-we-are">MORE →</router-link>
        </div>
        <div class="who-we-are-image">
          <img src="@/assets/1748079519.png" alt="Modern Cityscape" class="who-we-are-img">
        </div>
      </div>
    </section>

    <section class="what-we-offer-section" style="background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%)">
      <div class="container">
        <h2 style="color: white">WHAT WE OFFER</h2>
        <div class="underline"></div>
        <p class="offer-description" style="color: white">
          Pulse Creative Solutions focuses on supplying a wide variety of high-energy efficient unique technology solutions, 
          modern web development, mobile applications, and cloud infrastructure for the digital transformation of businesses.
        </p>
        
        <div class="services-grid redesigned">
          <div class="service-card">
            <div class="service-image">
              <img src="@/assets/1748079590696961.png" alt="Customer Service" class="service-img">
            </div>
            <div class="service-content">
              <div class="service-accent"></div>
              <h3 class="service-title">Customer Services Outsourcing</h3>
              <p class="service-description">Ensure top‑notch customer communication with our dedicated, scalable teams.</p>
            </div>
          </div>
          
          <div class="service-card">
            <div class="service-image">
              <img src="@/assets/1748079638534021.png" alt="Marketing Campaigns" class="service-img">
            </div>
            <div class="service-content">
              <div class="service-accent"></div>
              <h3 class="service-title">Strategic Marketing Campaigns</h3>
              <p class="service-description">Amplify your market presence through data‑driven strategy and execution.</p>
            </div>
          </div>
          
          <div class="service-card">
            <div class="service-image">
              <img src="@/assets/1748079678463132.png" alt="Data Processing" class="service-img">
            </div>
            <div class="service-content">
              <div class="service-accent"></div>
              <h3 class="service-title">Data Entry & Processing</h3>
              <p class="service-description">Enhance data management efficiency with accurate, secure processing.</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="cta-section">
      <div class="container">
        <div class="cta-content">
          <h2>Ready to Transform Your Business?</h2>
          <p>Let's discuss how our technology solutions can help you achieve your goals and drive growth.</p>
          <div class="cta-buttons">
            <router-link to="/contact" class="btn btn-primary" style="  color: white; background: #6b7c32;  border: 2px solid #6b7c32;">Start Your Project</router-link>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'HomeView'
}
</script>

<style scoped>
.home-page {
  padding-top: 70px;
}

/* Hero Section */
.hero-section {
  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);
  background-image: linear-gradient(
      rgba(0,0,0,0.5),   /* 半透明黑色 */
      rgba(0,0,0,0.5)
    ),url('../assets/M2WCzEDdTKy4my3YImKsNJxCmERdqdmhnD8fH7jw.jpg');
  color: white;
  padding: 100px 0;
  min-height: 80vh;
  display: flex;
  align-items: center;
  justify-content: center; /* 水平居中容器 */
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* 专门用于Hero Section的容器样式 */
.hero-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 30px;
}

.hero-content {
  max-width: 800px;
}

.hero-content h1 {
  font-size: 3.5rem;
  margin-bottom: 20px;
  font-weight: 700;
  line-height: 1.2;
  color: white;
}

.hero-content p {
  font-size: 1.3rem;
  margin-bottom: 40px;
  opacity: 0.9;
  line-height: 1.6;
  color: white;
}

.hero-buttons {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  justify-content: center; /* 居中按钮组 */
}

/* Who We Are Section */
.who-we-are-section {
  background: white;
  padding: 100px 0;
}

.who-we-are-section .container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: center;
}

.who-we-are-content {
  order: 2;
  padding-left: 40px;
}

.who-we-are-image {
  order: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.who-we-are-badge {
  color: #6b7c32;
  font-size: 2rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 2px;
  margin-bottom: 20px;
}

.who-we-are-content h2 {
  font-size: 3.5rem;
  margin-bottom: 40px;
  font-weight: 700;
  line-height: 1.2;
  color: #2c3e50;
}

.who-we-are-img {
  width: 100%;
  height: 400px;
  object-fit: cover;
  border-radius: 12px;
  box-shadow: 0 20px 40px rgba(0,0,0,0.1);
}

.btn-who-we-are {
  background: #6b7c32;
  color: white;
  border: 2px solid #6b7c32;
  padding: 15px 30px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 1rem;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.btn-who-we-are:hover {
  background: #5a6b2a;
  border-color: #5a6b2a;
  transform: translateY(-2px);
}

.btn {
  padding: 15px 30px;
  border-radius: 30px;
  text-decoration: none;
  font-weight: 600;
  font-size: 1.1rem;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  display: inline-block;
  text-align: center;
  position: relative;
  overflow: hidden;
}

.btn-primary {
  background: white;
  color: #2c3e50;
  border: 2px solid white;
}

.btn-primary:hover {
  background: transparent;
  color: white;
  transform: translateY(-2px);
}

.btn-secondary {
  background: transparent;
  color: white;
  border: 2px solid white;
}

.btn-secondary:hover {
  background: white;
  color: #2c3e50;
  transform: translateY(-2px);
}

.btn-outline {
  background: transparent;
  color: white;
  border: 2px solid white;
}

.btn-outline:hover {
  background: white;
  color: #2c3e50;
  transform: translateY(-2px);
}

/* WHAT WE OFFER Section */
.what-we-offer-section {
  padding: 30px 0;
  background-color: #2c3e50;
  color: white;
}

.what-we-offer-section .container {
  text-align: center;
}

h2 {
  font-size: 2rem;
  margin-bottom: 10px;
  font-weight: 700;
}

.underline {
  width: 50px;
  height: 3px;
  background-color: #6b7c32;
  margin: 0 auto 20px;
  border-radius: 2px;
}

.offer-description {
  font-size: 1rem;
  max-width: 750px;
  margin: 0 auto 30px;
  line-height: 1.5;
  color: #ecf0f1;
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}

.service-card {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  text-align: left;
  box-shadow: 0 4px 15px rgba(0,0,0,0.08);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.service-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 30px rgba(0,0,0,0.12);
}

.service-image img {
  width: 100%;
  height: 160px;
  object-fit: cover;
}

.service-content {
  padding: 15px;
}

.service-accent {
  width: 40px;
  height: 3px;
  background: #6b7c32;
  margin-bottom: 8px;
  border-radius: 2px;
}

.service-content h3 {
  font-size: 1.1rem;
  margin-bottom: 5px;
  color: #2c3e50;
}

.service-content p {
  font-size: 0.9rem;
  line-height: 1.4;
  color: #555;
}

/* Features Section */
.features-section {
  padding: 100px 0;
  background-color: #f8f9fa;
}

.features-section h2 {
  text-align: center;
  font-size: 2.5rem;
  margin-bottom: 60px;
  color: #333;
  font-weight: 600;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 40px;
  max-width: 1000px;
  margin: 0 auto;
}

.feature-card {
  background: white;
  padding: 40px 30px;
  border-radius: 20px;
  text-align: center;
  box-shadow: 0 10px 30px rgba(0,0,0,0.1);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  border: 1px solid #e9ecef;
}

.feature-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 20px 40px rgba(0,0,0,0.15);
}

.feature-icon {
  font-size: 3rem;
  margin-bottom: 20px;
}

.feature-card h3 {
  font-size: 1.5rem;
  margin-bottom: 15px;
  color: #333;
  font-weight: 600;
}

.feature-card p {
  color: #666;
  line-height: 1.6;
  font-size: 1rem;
}

.stats-section {
  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);
  color: white;
  padding: 80px 0;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 40px;
  text-align: center;
}

.stat-item {
  padding: 20px;
}

.stat-number {
  font-size: 3rem;
  font-weight: 700;
  margin-bottom: 10px;
  color: white;
}

.stat-label {
  font-size: 1.1rem;
  opacity: 0.9;
  font-weight: 500;
}

/* CTA Section */
.cta-section {
  background: #f8f9fa;
  padding: 100px 0;
  text-align: center;
}

.cta-section .container {
  display: flex;
  justify-content: center; /* 水平居中 */
}

.cta-content {
  text-align: center;
  max-width: 600px;
}

.cta-content h2 {
  font-size: 2.5rem;
  margin-bottom: 20px;
  color: #333;
  font-weight: 600;
}

.cta-content p {
  font-size: 1.2rem;
  color: #666;
  margin-bottom: 40px;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

.cta-buttons {
  display: flex;
  gap: 20px;
  justify-content: center;
  flex-wrap: wrap;
}

/* 响应式设计 */
@media screen and (max-width: 992px) {
  .hero-buttons {
    justify-content: center;
  }
  .hero-img {
    width: 100%;
  }
  .services-grid {
    grid-template-columns: 1fr 1fr;
  }

  .who-we-are-section .container {
    grid-template-columns: 1fr;
    gap: 40px;
    text-align: center;
  }

  .who-we-are-content {
    order: 1;
    padding-left: 0;
  }

  .who-we-are-image {
    order: 2;
  }
}

@media screen and (max-width: 768px) {
  .hero-content h1 {
    font-size: 2.5rem;
  }
  
  .hero-img {
    height: 300px;
  }
  
  .who-we-are-content h2 {
    font-size: 2.5rem;
  }
  
  .who-we-are-img {
    height: 300px;
  }
  
  .what-we-offer-section h2 {
    font-size: 2rem;
  }
  
  .offer-description {
    font-size: 1.2rem;
    max-width: 700px;
  }
  
  .features-section h2 {
    font-size: 2rem;
  }
  
  .services-grid {
    grid-template-columns: 1fr;
    gap: 24px;
  }
  
  .features-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 30px;
    max-width: 600px;
  }
  
  .stats-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 30px;
  }
  
  .cta-buttons {
    flex-direction: column;
    align-items: center;
  }
  
  .btn {
    width: 200px;
  }
}

@media screen and (max-width: 600px) {
  .services-grid {
    grid-template-columns: 1fr;
  }
  .offer-description {
    font-size: 0.95rem;
  }
}

@media screen and (max-width: 480px) {
  .hero-section {
    padding: 60px 0;
  }
  
  .hero-content h1 {
    font-size: 2rem;
  }
  
  .container {
    padding: 0 15px;
  }
  
  .feature-card {
    padding: 30px 20px;
  }
  
  .stats-grid {
    grid-template-columns: 1fr;
  }
  
  .stat-number {
    font-size: 2.5rem;
  }
  
  .features-grid {
    grid-template-columns: 1fr;
    gap: 25px;
    max-width: 400px;
  }
  
  .services-grid {
    grid-template-columns: 1fr;
    gap: 22px;
    max-width: 520px;
    margin: 0 auto;
  }
  
  .offer-description {
    font-size: 1.1rem;
    max-width: 500px;
  }
  
  .cta-content h2 {
    font-size: 1.8rem;
  }
  
  .cta-content p {
    font-size: 1rem;
  }
}
</style>